import {RULE_TYPE_CONTAINS, RULE_TYPE_EQUALS, RULE_TYPE_STARTS_WITH} from "../codes";

export const listToMap = (list, key) => {
  const res = {};

  list.forEach(item => res[item[key]] = item);

  return res;
}

export const getOrDefault = (value, valueIfUndefined) => value === undefined || value === null ? valueIfUndefined : value;

export const findRule = (transactionRules, payee) => {
  payee = payee.toUpperCase();

  return transactionRules.find(r => {
    const value = r.value.toUpperCase();

    if (r.type === RULE_TYPE_CONTAINS) {
      return payee.indexOf(value) > -1;
    } else if (r.type === RULE_TYPE_EQUALS) {
      return payee === value;
    } else if (r.type === RULE_TYPE_STARTS_WITH) {
      return payee.startsWith(value);
    } else {
      return payee.endsWith(value);
    }
  });
}

export const round = (number, decimals) => Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

export const sortTransactionsAsc = (a, b) => {
  if (a.valueDate > b.valueDate) {
    return 1;
  } else if (a.valueDate < b.valueDate) {
    return -1;
  }

  return a.createTime.localeCompare(b.createTime);
}

export const formatDuration = (hoursDecimal) => {
  if (hoursDecimal === undefined || hoursDecimal === null || isNaN(hoursDecimal) || String(hoursDecimal).length === 0) {
    return "";
  }

  const totalMinutes = Math.round(hoursDecimal * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const hStr = String(hours);

  if (minutes === 0) {
    return `${hStr}h`;
  }

  const mStr = String(minutes).padStart(2, "0");

  return `${hStr}h${mStr}`;
};

export const renderDescription = (description) => {
  if (!description) {
    return "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(description, "text/html");

  const processNode = (node) => {
    // If the node is already an anchor, do not replace URLs inside it
    if (node.nodeName === "A") {
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const urlRegex = /(https?:\/\/[^\s]+)/gi;

      if (urlRegex.test(text)) {
        const parts = text.split(urlRegex);
        const fragment = document.createDocumentFragment();

        parts.forEach((part) => {
          if (part.match(urlRegex)) {
            let url = part;
            let trailing = "";

            while (url.length > 0) {
              const lastChar = url[url.length - 1];

              if (/[.,;!?']/.test(lastChar)) {
                trailing = lastChar + trailing;
                url = url.slice(0, -1);
              } else if (lastChar === ")") {
                const openCount = (url.match(/\(/g) || []).length;
                const closeCount = (url.match(/\)/g) || []).length;

                if (closeCount > openCount) {
                  trailing = lastChar + trailing;
                  url = url.slice(0, -1);
                } else {
                  break;
                }
              } else {
                break;
              }
            }

            const displayUrl = url.length > 50 ? url.substring(0, 50) + "..." : url;

            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.textContent = displayUrl;

            fragment.appendChild(link);
            if (trailing) {
              fragment.appendChild(document.createTextNode(trailing));
            }
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });

        node.parentNode.replaceChild(fragment, node);
      }
      return;
    }

    const children = Array.from(node.childNodes);
    children.forEach(processNode);
  };

  processNode(doc.body);
  return doc.body.innerHTML;
};
